import { library } from '@fortawesome/fontawesome-svg-core';
import { faMagic } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { ClickAwayListener } from '@mui/base';
import { Button, Dropdown, Menu, MenuButton, MenuItem } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { CursorGuidesCheckboxContainer } from '../../../../modules/editor/cursorControl/cursorGuidesCheckbox/CursorGuidesCheckbox.container';
import { CursorVisibilityCheckboxContainer } from '../../../../modules/editor/cursorControl/cursorVisibilityCheckbox/CursorVisibilityCheckbox.container';
import { OpacityContainer } from '../containers/OpacityContainer';
import { ZoomContainer } from '../containers/ZoomContainer';

library.add(faMagic);

interface IProps {
  disableCursorConfig: boolean;
}

export const AnnotationViewOptions = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { disableCursorConfig } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <ClickAwayListener
      onClickAway={() => {
        setIsOpen(false);
      }}
    >
      <div>
        <Dropdown open={isOpen}>
          <MenuButton
            tabIndex={-1}
            onClick={() => {
              setIsOpen((x) => !x);
            }}
            slots={{ root: Button }}
            slotProps={{ root: { variant: 'topbar', color: 'neutral', startDecorator: <FontAwesomeIcon icon={faMagic} /> } }}
          >
            {t('view_options')}
          </MenuButton>
          <Menu className='no-hover'>
            <MenuItem>
              <ZoomContainer />
            </MenuItem>
            <MenuItem>
              <OpacityContainer />
            </MenuItem>
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <CursorVisibilityCheckboxContainer disabled={disableCursorConfig} />
            </MenuItem>
            <MenuItem>
              <CursorGuidesCheckboxContainer disabled={disableCursorConfig} />
            </MenuItem>
          </Menu>
        </Dropdown>
      </div>
    </ClickAwayListener>
  );
});
